import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./dashboard.css";
import "./component/partials/sidebar/Sidebar.scss";
import { Products } from "./component/pages/Products";
import { ProductBatch } from "./component/pages/ProductBatch";
import { Orders } from "./component/pages/Orders";
import Reports from "./component/pages/Reports";
import { Profile } from "./component/pages/Profiles";
import { Nopage } from "./component/pages/Nopage";
import { Sales } from "./component/pages/Sales";
import { StockAdjustment } from "./component/pages/StockAdjustment";
import { Login } from "./component/pages/Login";
import { ResetEmailSent } from "./component/pages/ResetEmailSent";
import { Signup } from "./component/pages/Signup";
import { Forget } from "./component/pages/Forget";
import { Reset } from "./component/pages/Reset";
import { Dashboard } from "./component/pages/Dashboard";
import { Customer } from "./component/pages/Customer";
import { Category } from "./component/pages/Category";
import Sidebar from "./component/partials/sidebar/Sidebar";
import { Layout } from "./component/pages/Layout";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getLoginStatus } from "./services/authService";
import { SET_LOGIN } from "./redux/features/auth/authSlice";
import { UpdateProfile } from "./component/pages/UpdateProfile";
import { Users } from "./component/pages/Users";
import { Expense } from "./component/pages/Expense";
import { EditExpense } from "./component/pages/edit/EditExpense";
import ContactUs from "./component/pages/ContactUs";
import { Home1 } from "./component/pages/Home";
import { Attribute } from "./component/pages/Attributes";
import { SaleReturn } from "./component/pages/SaleReturn";
import { ShiftClosing } from "./component/pages/ShiftClosing";

axios.defaults.withCredentials = true;

function App() {

  const dispatch = useDispatch();
  useEffect(() => {
    async  function loginStatus() {
      const status = await getLoginStatus();
      dispatch(SET_LOGIN(status));
    }
    loginStatus();
    }, [dispatch])


  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Home1 />} />

        <Route path="/Dashboard" element={
        <Sidebar>
          <Layout>
            <Dashboard />
          </Layout>
        </Sidebar>} />

        <Route path="/Category" element={
        <Sidebar>
          <Layout>
            <Category />
          </Layout>
        </Sidebar>} />

        <Route path="/Attributes" element={
        <Sidebar>
          <Layout>
            <Attribute />
          </Layout>
        </Sidebar>} />

          <Route path="/Customer" element={
        <Sidebar>
          <Layout>
            <Customer />
          </Layout>
        </Sidebar>} />

        <Route path="Products" element={
        <Sidebar>
          <Layout>
            <Products />
          </Layout>
        </Sidebar>} />

        <Route path="product-batches" element={
        <Sidebar>
          <Layout>
            <ProductBatch />
          </Layout>
        </Sidebar>} />
        
        <Route path="Orders" element={
        <Sidebar>
          <Layout>
            <Orders />
          </Layout>
        </Sidebar>} />
        
        <Route path="Reports" element={
        <Sidebar>
          <Layout>
            <Reports />
          </Layout>
        </Sidebar>} />

        <Route path="Sales" element={
        <Sidebar>
          <Layout>
            <Sales />
          </Layout>
        </Sidebar>} />

        <Route path="Sale-Returns" element={
        <Sidebar>
          <Layout>
            <SaleReturn />
          </Layout>
        </Sidebar>} />

        <Route path="Shift-Closing" element={
        <Sidebar>
          <Layout>
            <ShiftClosing />
          </Layout>
        </Sidebar>} />

        <Route path="Stock-Adjustment" element={
        <Sidebar>
          <Layout>
            <StockAdjustment />
          </Layout>
        </Sidebar>} />

        <Route path="Expenses" element={
        <Sidebar>
          <Layout>
            <Expense />
          </Layout>
        </Sidebar>} />

        <Route path="/Expenses/edit-expense/:id" element={
        <Sidebar>
          <Layout>
            <EditExpense />
          </Layout>
        </Sidebar>} />
        
        <Route path="Users" element={
        <Sidebar>
          <Layout>
            <Users />
          </Layout>
        </Sidebar>} />

        <Route path="Profile" element={
        <Sidebar>
          <Layout>
            <Profile />
          </Layout>
        </Sidebar>} />

        <Route path="update-profile" element={
        <Sidebar>
          <Layout>
            <UpdateProfile />
          </Layout>
        </Sidebar>} />

        <Route path="ContactUs" element={
        <Sidebar>
          <Layout>
            <ContactUs />
          </Layout> 
        </Sidebar>} />

        <Route path="Signin" element={<Login />} />
        <Route path="ResetEmailSent" element={<ResetEmailSent />} />
        <Route path="Login" element={<Login />} />
        <Route path="Signup" element={<Signup />} />
        <Route path="Signout" element={<Login />} />
        <Route path="Logout" element={<Login />} />
        <Route path="ForgotPassword" element={<Forget />} />
        <Route path="ResetPassword/:resetToken" element={<Reset />} />
        <Route path="*" element={<Nopage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
